<template>
    <div class="-container-fluid -align-self-start">

        <!-- {{  props.filter }} -->

    <div class="row">
        <div class="col-6">

            <div class="row">
                <div class="col">
                    <div class="d-block"><span>Client:</span></div>
                    <client-ac 
                        inputclass="form-control" 
                        v-model="filter.client"
                    ></client-ac>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <tech-select 
                        @change="" 
                        v-model="filter.user"
                    ></tech-select>
                </div> 
            </div>

            
        </div>
        <div class="col-6">
            <!-- {{ filter.status }} -->

            <kt-select
                label="Choose Status"
                placeholder="Choose Job Status"
                :options="jobStatus"
                value-key="value"
                label-key="label"
                :multiple="true"
                v-model="filter.status"
            ></kt-select>

            <!-- 
            <kt-input 
                label="Start Date" 
                type="date" 
                v-model="filter.startDate"
            ></kt-input>
            -->
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-4">
            <button class="form-control btn btn-secondary" @click="$emit('dismiss')">
                Cancel
            </button>
        </div>
        <div class="col-4">
            <button class="form-control btn btn-warning" @click="clear()">
                Clear
            </button>
        </div>
        <div class="col-4">
            <button class="form-control btn btn-primary" @click="setFilter()">
                Set Filter
            </button>
        </div>
    </div>

</div>
</template>


<script setup>

import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Helper from "@/services/Helper";
import Attic from "@/services/Attic";
import ClientAc from "@/components/Clients/ClientAc.vue";
import JobSelect from "@/components/Jobs/JobSelect.vue";
import TechSelect from "@/components/Techs/TechSelect.vue";
import KtSelect from "@/components/UI/KtSelect.vue";
import KtInput from "@/components/UI/KtInput.vue";

const route = useRoute();
const router = useRouter();

const emits = defineEmits([
    "update", "dismiss", 
]);

const jobStatus = ref(Attic.JobStatusList);

const props = defineProps({
    filter: {
        type: Object,
        default: {
            client: "",
            // job: "",
            user: "",
            // type: "",
            status: [],
            // startDate: "",
            // endDate: "",
            page: "",
        }
    },
    mode: {
        type: String,
        default: ""
    }
});

const getNewFilter = () =>
{
    return {
        client: "",
        // job: "",
        user: "",
        status: [],
        // type: "",
        // startDate: "",
        // endDate: "",
        page: "",
    };
};

const dateRange = ref("");
const filter = ref(getNewFilter());

watch(() =>
{
    return JSON.stringify(props.filter);
}, (nv, ov) => {
    if (nv) {
        filter.value = props.filter;
    }
}, { immediate: true })


// TODO - convert into utility function
const setDateRange = (type) =>
{
    let ret = Helper.getDateRange(type);
    filter.value.startDate = ret[0];
    filter.value.endDate = ret[1];

    dateRange.value = "";
};

const setFilter = () =>
{
    // STORE FILTER IN THE CACHE ...

    let flt = Helper.toUrlParams(filter.value);
    emits("update", flt);
    emits("dismiss");
};

const clear = () =>
{
    filter.value = getNewFilter();
};

onMounted(() =>
{
    // PULL FROM THE URL FILTER
    // alert(route.params.filter);
});

</script>